module.exports = __webpack_public_path__ + "img/no-car.821cf0ed.png";